/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup'

import {
  CREATE_NOTIFICATIONS_FOR_SMS,
  GET_NOTIFICATION_CONTRACTS,
  GET_NOTIFICATION_CONTRACTS_CALL,
  GET_NOTIFICATION_CONTRACTS_CALL_EX,
  GET_NOTIFICATION_CONTRACTS_IS_RESTRUCTURING_AGING_MORE_THAN_90_DAYS,
  GET_NOTIFICATION_CONTRACTS_IS_RULED_BUT_NOT_RESTRUCTURING,
  GET_NOTIFICATION_CONTRACTS_PRINCIPLE_BALANCE_IS_ZERO,
  GET_NOTIFICATION_CONTRACTS_SMART_APP,
  GET_NOTIFICATION_CURRICULUM_EXTERNALS,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_CALL,
  GET_NOTIFICATIONS_CALL_EX ,
  GET_NOTIFICATIONS_LAWYER,
  GET_NOTIFICATIONS_SMART_APP,
  GET_NOTIFICATION_CONTRACTS_IS_DRAFT,
  INSPECTIONED_CONTRACT_WITH_SMART_APP,
  REJECTED_CONTRACT_WITH_SMART_APP,
  SUCCESS_CONTRACT_WITH_SMART_APP
} from '@/queries/modules/notification'

import {addItemSuccess, error, updateItemSuccess,} from '@/utils/notification'

export async function getNotifications(context, payload) {
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotifications} = data

    context.commit('setNotifications', getNotifications)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContracts(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action,
    loanDetailPlanFilter: 'loanDateGteNow'//payload.loanDetailPlanFilter
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContracts} = data
    // console.log(data)
    context.commit('setNotificationContracts', getNotificationContracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsPrincipleBalanceIsZero(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action,
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS_PRINCIPLE_BALANCE_IS_ZERO,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContracts: notificationContracts} = data
    // console.log(notificationContracts)
    context.commit('setNotificationContracts', notificationContracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsIsRuledButNotRestructuring(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action,
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS_IS_RULED_BUT_NOT_RESTRUCTURING,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContracts: notificationContracts} = data
    context.commit('setNotificationContracts', notificationContracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsIsRestructuringAgingMoreThan90Days(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action,
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS_IS_RESTRUCTURING_AGING_MORE_THAN_90_DAYS,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContracts: notificationContracts} = data
    context.commit('setNotificationContracts', notificationContracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationCurriculumExternalsNotMapping(context, payload) {
  // console.log('Get Notification Curriculum Externals Not Mapping...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action,
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CURRICULUM_EXTERNALS,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationCurriculumExternals} = data
    context.commit('setNotificationCurriculumExternals', getNotificationCurriculumExternals)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationsCall(context, payload) {
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATIONS_CALL,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationsCall} = data
    context.commit('setNotificationsCall', getNotificationsCall)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationsCallEx(context) {
  try {
    const response = await apolloClient.query({
      query: GET_NOTIFICATIONS_CALL_EX,
      fetchPolicy: 'network-only'
    });
    const { data } = response;
    const { getNotificationsCallEx } = data;

    context.commit('setNotificationsCallEx', getNotificationsCallEx);
  } catch (e) {
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsCall(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS_CALL,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContractsCall: notificationContractsCall} = data
    context.commit('setNotificationContractsCall', notificationContractsCall)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsCallEx(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  const variables = {
    action: payload.action,
    userId: payload.userId || null // Optional userId for assigned calls
  };

  try {
    const response = await apolloClient.query({
      query: GET_NOTIFICATION_CONTRACTS_CALL_EX,
      variables,
      fetchPolicy: 'network-only'
    });

    const { data } = response;
    const { getNotificationContractsCallEx: notificationContractsCallEx } = data;

    context.commit('setNotificationContractsCallEx', notificationContractsCallEx);
    context.commit('setSuccess', null);
  } catch (e) {
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationsLawyer(context, payload) {
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATIONS_LAWYER,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationsLawyer} = data
    context.commit('setNotificationsLawyer', getNotificationsLawyer)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationsSale(context, payload) {
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATIONS_SMART_APP,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationsSale} = data
    context.commit('setNotificationsSale', getNotificationsSale)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsSale(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS_SMART_APP,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContractsSale} = data

    context.commit('setNotificationContractsSale', getNotificationContractsSale)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationContractsIsDraft(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    action: payload.action,
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_CONTRACTS_IS_DRAFT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getNotificationContracts: notificationContracts} = data
    // console.log("notificationContracts", notificationContracts)
    context.commit('setNotificationContracts', notificationContracts)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function rejectedContractWithSmartApp(context, payload) {
  // console.log('Delete Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.id,
      payload: payload.form
    }
    await apolloClient
      .mutate({
        mutation: REJECTED_CONTRACT_WITH_SMART_APP,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function inspectionedContractWithSmartApp(context, payload) {
  // console.log('Delete Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.id,
    }
    await apolloClient
      .mutate({
        mutation: INSPECTIONED_CONTRACT_WITH_SMART_APP,
        variables,
        fetchPolicy: 'no-cache'
      })

    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function successContractWithSmartApp(context, payload) {
  // console.log('Delete Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.id
    }
    await apolloClient
      .mutate({
        mutation: SUCCESS_CONTRACT_WITH_SMART_APP,
        variables,
        fetchPolicy: 'no-cache'
      })
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function createNotificationsForSms(context, payload) {
  // console.log('Add NotificationsForSms...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    contractIds: payload.contractIds,
    title: payload.form.title,
    description: payload.form.description
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_NOTIFICATIONS_FOR_SMS,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}
